import { render, staticRenderFns } from "./ProjectCloudStorage.vue?vue&type=template&id=58beca78&scoped=true&"
import script from "./ProjectCloudStorage.vue?vue&type=script&lang=js&"
export * from "./ProjectCloudStorage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58beca78",
  null
  
)

export default component.exports